import useModuleTranslation from "../infra-no-ui/translation/useModuleTranslation.js";
import React from "react";

/**
 * Dynamically load translation files pertaining to the email subscription module.
 * @return {*}
 */
export default function useTranslationEmailSubscription() {
  // Imports must be memoized so that they don't change on every render
  const imports = React.useMemo(
    () => ({
      en: import("./locales/en/email-subscription.json"),
      fr: import("./locales/fr/email-subscription.json"),
    }),
    []
  );

  return useModuleTranslation("email-subscription", imports);
}
